import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { MessageService } from '../services/message/message.service';

export const pushAlertGuard: CanActivateFn = (route) => {
  const messageService = inject(MessageService);
  const router = inject(Router);
  const messageId = Number(route.queryParamMap.get('messageId'));
  if (messageId) void messageService.markPushNotificationAsRead(messageId);
  const target = messageService.getPushNotificationTarget(
    route.queryParamMap.get('redirectType'),
    route.queryParamMap.get('redirectId'),
  );
  return target
    ? router.createUrlTree([target.path], { queryParams: target.queryParams })
    : router.createUrlTree(['/']);
};
